export const BASE_URL = 'https://actions-prod.artzen.io';
// export const BASE_URL='http://localhost:4000'
export const FRONT_END_URL = 'https://wise.artzen.io';
export const type = ['bid', 'invitation'];
export const hardCodedPermissions = [
  'developer',
  'admin',
  'sales',
  'seo',
  'hr',
  'business'
];
export const todoPriority = ['urgent', 'medium', 'low'];
export const COLUMN_NAMES = {
  DO_IT: 'To do',
  IN_PROGRESS: 'In progress',
  AWAITING_REVIEW: 'Awaiting review',
  DONE: 'Done'
};
